import React from 'react';
import { Row, Col, Form, FormGroup, Button, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import Card from '../../Card/Card';
import StreamTDSMain from './../StreamTDSMain';
import StreamTDSScriptMain from './../StreamTDSScriptMain';
import { FMessage } from '../../../hoc/IntlComponents';
import FlowToggleBtns from '../../Flow/FlowToggleBtns';


const View = ({
  data: {
    errors,
    scripts,
    subAccount,
    flowsInfo,
    offersInfo,
    notFoundOffersInStreams,
    loading,
    defaultStreams,
    settingsTDS,
    offers,
    flow,
    title,
    isUserBlocked,
    isEdit,
    link,
    streamLink,
    streamTDS,
    settings,
  },
  handleChange,
  handleSubmit,
  onSelectChange,
  getFlowsInfo,
  handleSubAccountChange,
  getComputedLink,
  _alertRefs,
  saveRef,
  setFlowInfo,
  getOffersInfo,
  handleScriptTitleChange,
  onSelectScriptDefaultStreamChange,
  onRemoveScript,
  onAddScript,
  onSelectScriptOptionType,
  onAddNewScriptOption,
  deleteScriptOption,
  onChangeScriptOptionValue,
}) => {
  return (
    <Form className="flow-form stream-tds" onSubmit={handleSubmit}>
      <Card loading={loading}>
        <Card.Header>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/tools/flows">
                <FMessage id="flows.breadcrumb" />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>{isEdit ? title : <FMessage id="flowTDS.breadcrumb" />}</BreadcrumbItem>
          </Breadcrumb>
        </Card.Header>
        <Card.Body>
          {isEdit && (
            <Row>
              <Col>
                <h3>
                  <FMessage id="streamTDS.header.edit" />
                </h3>
              </Col>
            </Row>
          )}
          {!isEdit && <FlowToggleBtns />}
          <StreamTDSMain
            clickDomains={settings.clickDomains}
            link={link}
            title={title}
            errors={errors}
            handleChange={handleChange}
            flow={flow}
            onSelectChange={onSelectChange}
            defaultStreams={defaultStreams}
            isEdit={isEdit}
            offers={offers}
            getFlowsInfo={getFlowsInfo}
            flowsInfo={flowsInfo}
            offersInfo={offersInfo}
            streamLink={streamLink}
            streamTDS={streamTDS}
            handleSubAccountChange={handleSubAccountChange}
            getComputedLink={getComputedLink}
            subAccount={subAccount}
            _alertRefs={_alertRefs}
            saveRef={saveRef}
            notFoundOffersInStreams={notFoundOffersInStreams}
            setFlowInfo={setFlowInfo}
            getOffersInfo={getOffersInfo}
          />
        </Card.Body>
      </Card>
      <Card loading={loading}>
        <StreamTDSScriptMain
          scripts={scripts}
          onChangeScriptTitle={handleScriptTitleChange}
          errors={errors}
          defaultStreams={defaultStreams}
          onSelectScriptDefaultStreamChange={onSelectScriptDefaultStreamChange}
          onRemoveScript={onRemoveScript}
          onAddScript={onAddScript}
          settingsTDS={settingsTDS}
          onSelectScriptOptionType={onSelectScriptOptionType}
          onAddNewScriptOption={onAddNewScriptOption}
          deleteScriptOption={deleteScriptOption}
          onChangeScriptOptionValue={onChangeScriptOptionValue}
          offers={offers}
          getFlowsInfo={getFlowsInfo}
          flowsInfo={flowsInfo}
          offersInfo={offersInfo}
          _alertRefs={_alertRefs}
          saveRef={saveRef}
          notFoundOffersInStreams={notFoundOffersInStreams}
          setFlowInfo={setFlowInfo}
          getOffersInfo={getOffersInfo}
        />
      </Card>

      <Row>
        <Col>
          <FormGroup>
            <Button
              className="btn-lead"
              size="lg"
              color="primary"
              disabled={loading || isUserBlocked}
            >
              {isEdit ? (
                <FMessage id="flowTDS.buttons.save" />
              ) : (
                <FMessage id="flowTDS.buttons.create" />
              )}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};


export default View;
